/**
 * Created by 胡长伟 on 2021-06-20.
 */

import { Utils } from '../../app.base'
import comnApi  from '../../api/comn'

/*
 * 从可能分摊的条目汇总 金额分摊总额
 * 注意：shareItems 应包含未实际参与分摊的条目
 */
export function sumFeeAmount(shareItems, fracDigits) {
    if(shareItems == null) {
        shareItems = [];
    }
    if(fracDigits == null) {
        fracDigits = 2;
    }
    let price = null;
    let amount = null;
    let tmpItem = null;

    let accumAmount = 0; // 累计分摊金额
    for(let i = 0, c = shareItems.length; i < c; i++) {
        tmpItem = shareItems[i];
        price = Utils.ParseFloat(tmpItem.price);
        if(price == null) {
            price = 0;
        } else {
            price = price.round(fracDigits);
        }
        amount = price * tmpItem.quantity;
        //
        tmpItem.price = price;
        tmpItem.amount = amount;
        tmpItem.splitted = false;
        accumAmount += amount;
    }
    //
    return accumAmount.round(fracDigits);
}

/*
 * 检查金额分摊是否有误差（返回误差错误信息）
 * 注意：shareItems 应包含未实际参与分摊的条目
 */
export function checkShareAmounts(shareItems, shareAmount, fracDigits) {
    if(shareAmount == null) {
        shareAmount = 0;
    }
    if(shareItems == null) {
        shareItems = [];
    }
    if(fracDigits == null) {
        fracDigits = 2;
    }
    // 容差数值
    let errValve = Math.pow(10, fracDigits * -1);
    //
    let price = null;
    let amount = null;
    let tmpItem = null;
    let tmpAmount = null;

    let errAmount = 0;
    let accumAmount = 0; // 已累计分摊金额
    for(let i = 0, c = shareItems.length; i < c; i++) {
        tmpItem = shareItems[i];
        price = Utils.ParseFloat(tmpItem.price);
        if(price == null) {
            price = 0;
            tmpAmount = 0;
        } else {
            if(price < 0) {
                return "第 " + (i + 1) + " 条（" + tmpItem.ukId + "）的分摊单价有误（不能 < 0）";
            }
            price = price.round(fracDigits);
            tmpAmount = price * tmpItem.quantity;
        }
        amount = Utils.ParseFloat(tmpItem.amount);
        if(amount == null) {
            amount = 0;
        } else {
            amount = amount.round(fracDigits);
        }
        //
        tmpItem.price = price;
        tmpItem.amount = amount;
        // 检查小计误差
        errAmount = Math.abs(amount - tmpAmount).round(fracDigits);
        if(errAmount >= errValve) {
            return "第 " + (i + 1) + " 条（" + tmpItem.ukId + "）的分摊小计 存在 " + errAmount.round(fracDigits) + " 的误差";
        }
        accumAmount += amount;
    }
    // 检查合计误差
    errAmount = Math.abs(shareAmount - accumAmount).round(fracDigits);
    if(errAmount >= errValve) {
        return "分摊合计 与 分摊总额 存在 " + errAmount.round(fracDigits) + " 的误差";
    }
    //
    return null;
}

export function getPriceInfo(priceList, callback) {
    comnApi.getPriceInfo({ itemList: priceList }, function (result){
        callback(result.data);
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/comn/funcs.js
// module id = 306
// module chunks = 0